module.exports = __webpack_public_path__ + "img/elburg-n1.a6356c73.jpg";